import 'css-chunksrc/client/scenes/projectCreationForm/projectToolsConfiguration/styles.scss';export default {
  "globalSettings": "_globalSettings_1w7ff_1",
  "title": "_title_1w7ff_8",
  "input": "_input_1w7ff_14",
  "label": "_label_1w7ff_22",
  "parameters": "_parameters_1w7ff_28",
  "parameter": "_parameter_1w7ff_28",
  "icon": "_icon_1w7ff_39",
  "iconBox": "_iconBox_1w7ff_47",
  "name": "_name_1w7ff_59",
  "description": "_description_1w7ff_65",
  "toggle": "_toggle_1w7ff_73",
  "timeSheets": "_timeSheets_1w7ff_79"
};